import {
  Heading,
  InputField,
  RadioButton,
  SelectDropdown,
  Datepicker,
  Button,
  Checkbox,
} from "@/common/components";
import { Constants } from "@/utils/Constants";
import { useCallback, useContext } from "@/common/hooks";
import { ProductContext } from "../ViewProductDetails";

const ProductPageOne = ({ next = () => {} }) => {
  const {
    labels,
    onChange,
    errorProps,
    productData,
    setProductData,
    closeAtCheckboxDisabled,
    addProduct,
    errors,
    closeDateCheckbox,
    setCloseDateCheckbox,
    reopenDateCheckbox,
    setReopenDateCheckbox,
    disabledActiveDate,
    copyProduct,
  } = useContext(ProductContext);

  const checkDisabled = useCallback(() => {
    let disable = false;

    Object.keys(errors).forEach((e) => {
      if (errors[e]) {
        disable = true;
      }
    });

    if (disable) {
      return true;
    }

    const requiredFields = ["name", "description", "inPlanCode"];

    requiredFields.forEach((e) => {
      if (!productData[e]) {
        disable = true;
      }
    });

    return disable;
  }, [productData, errors]);

  return (
    <section className="container-medium py-5">
      <div className="mb-3">
        <strong>{labels?.product?.externalProductId}</strong>
        {!addProduct && !copyProduct
          ? productData?.externalId
          : labels?.product?.externalIdDisplay}
      </div>

      <InputField
        id="productName"
        label={labels?.product?.productName}
        maxLength="35"
        change={(e) => onChange(e, "name")}
        {...errorProps("name")}
      />

      <InputField
        id="description"
        label={labels?.product?.description}
        isTextarea
        rows={6}
        maxLength={255}
        change={(val) => onChange(val, "description")}
        {...errorProps("description")}
      />

      <SelectDropdown
        id="productType"
        ariaLabel="product type"
        label={labels?.product?.productType}
        dropdownData={Constants.productTypes}
        selectClassName="w-100"
        select={(e) => {
          setProductData({
            ...productData,
            productType: e,
          });
        }}
        value={productData.productType}
        optionId="id"
        optionLabel="label"
        disabled={
          !addProduct && !copyProduct && productData?.setupComplete === "true"
        }
      />

      <RadioButton
        wrapperClassName="mb-4"
        data={Constants.productDistribution}
        value={productData.inPlanCode}
        selected={(e) =>
          setProductData({
            ...productData,
            inPlanCode: e,
          })
        }
        disabled={
          !addProduct && !copyProduct && productData?.setupComplete === "true"
        }
      />

      <>
        <Heading
          text={labels?.product?.productActivation}
          wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
          title={false}
        />
        <Datepicker
          id="activeDt"
          name="active date"
          wrapperClassName="form-group col-md-5 mb-4"
          label={labels?.product?.activeDt}
          value={productData.activeDt}
          min={new Date()}
          change={(e) => {
            setProductData({
              ...productData,
              activeDt: e,
            });
          }}
          disabled={!addProduct && disabledActiveDate}
        />

        <>
          <Checkbox
            wrapperClassName="mb-1"
            label={labels?.product?.closeAt}
            value={closeDateCheckbox}
            id="closedDt-checkbox"
            name="closedDt-checkbox"
            change={(e) => setCloseDateCheckbox(e)}
            disabled={closeAtCheckboxDisabled}
          />
          <Datepicker
            id="closedDt"
            name="Close At"
            wrapperClassName="form-group col-md-5 mb-4"
            value={productData.closedDt}
            min={new Date()}
            change={(e) => {
              setProductData({
                ...productData,
                closedDt: e,
              });
            }}
            disabled={!closeDateCheckbox || closeAtCheckboxDisabled}
          />
        </>

        <>
          <Checkbox
            wrapperClassName="mb-1"
            label={labels?.product?.reopenAt}
            value={reopenDateCheckbox}
            id="reopenDt-checkbox"
            name="reopenDt-checkbox"
            change={(e) => setReopenDateCheckbox(e)}
            disabled={productData?.status !== "closed"}
          />
          <Datepicker
            id="reopenDt"
            name="Reopen At"
            wrapperClassName="form-group col-md-5 mb-4"
            value={productData.reopenDt}
            min={new Date()}
            change={(e) => {
              setProductData({
                ...productData,
                reopenDt: e,
              });
            }}
            disabled={!reopenDateCheckbox}
          />
        </>
      </>

      <>
        <Heading
          text={`${labels?.product?.setupCompletionDate} ${
            productData?.setupCompleteDt
              ? `: ${productData?.setupCompleteDt}`
              : ""
          }`}
          wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
          title={false}
        />

        <Datepicker
          id="newInvestorCloseDt"
          name="New Ownership Close Date"
          wrapperClassName="form-group col-md-5 mb-4"
          label={labels?.product?.newInvestorCloseDt}
          value={productData.newInvestorCloseDt}
          min={new Date()}
          change={(e) => {
            setProductData({
              ...productData,
              newInvestorCloseDt: e,
            });
          }}
        />

        <Datepicker
          id="newPurchaseCloseDt"
          name="New Purchase Close Date"
          wrapperClassName="form-group col-md-5 mb-4"
          label={labels?.product?.newPurchaseCloseDt}
          value={productData.newPurchaseCloseDt}
          min={new Date()}
          change={(e) => {
            setProductData({
              ...productData,
              newPurchaseCloseDt: e,
            });
          }}
        />
      </>

      <Button
        id="next"
        text={labels?.product?.next}
        wrapperClassName="col-md-4 ms-auto"
        click={next}
        disabled={checkDisabled()}
      />
    </section>
  );
};

export default ProductPageOne;
